import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["panel"]

  connect() {
    // Add event listeners
    this.boundHandleKeyDown = this.handleKeyDown.bind(this)
    this.boundHandleClickOutside = this.handleClickOutside.bind(this)

    document.addEventListener('keydown', this.boundHandleKeyDown)
    document.addEventListener('click', this.boundHandleClickOutside)
  }

  disconnect() {
    // Clean up event listeners
    document.removeEventListener('keydown', this.boundHandleKeyDown)
    document.removeEventListener('click', this.boundHandleClickOutside)
  }

  open(event) {
    if (event) event.preventDefault()

    const slideOverContainer = this.element.querySelector('[role="dialog"]')
    slideOverContainer.classList.remove("hidden")

    setTimeout(() => {
      this.panelTarget.classList.remove("translate-x-full")
      this.panelTarget.classList.add("translate-x-0")
    }, 50)
  }

  close(event) {
    if (event) event.preventDefault()

    const slideOverContainer = this.element.querySelector('[role="dialog"]')

    this.panelTarget.classList.remove("translate-x-0")
    this.panelTarget.classList.add("translate-x-full")

    setTimeout(() => {
      slideOverContainer.classList.add("hidden")
    }, 500)
  }

  handleClickOutside(event) {
    const slideOverContainer = this.element.querySelector('[role="dialog"]')

    // Check if click is outside the panel and the slide-over is open
    if (!slideOverContainer.classList.contains("hidden") &&
      !this.panelTarget.contains(event.target) &&
      !event.target.closest('[data-action="click->slide-over#open"]')) {
      this.close()
    }
  }

  handleKeyDown(event) {
    if (event.key === "Escape") {
      this.close()
    }
  }
}
